<div class="container">
  @for (smallKeyValueIcon of leftIcons() ?? []; track $index) {
    <app-data-chip-icon [icon]="smallKeyValueIcon"></app-data-chip-icon>
  }
  @if (label()) {
    <div class="label">
      {{ label() }}
    </div>
  }

  @if (links() && links().length > 0) {
    @if(separateMultipleValues()){
      @for (link of links(); track $index; let isLast = $last) {
        <div class="link" [class.with-separator]="!isLast">
          <app-ui-link [title]="link.displayName" [path]="link.path" [target]="link.target" [isExternal]="link.isExternal ?? false"></app-ui-link>
        </div>
      }
    } @else {
      <div class="link">
          <app-ui-link [title]=" links()[0].displayName" [path]="links()[0].path" [target]="links()[0].target" [isExternal]="links()[0].isExternal ?? false"></app-ui-link>
      </div>

      @if(links().length > 1) {
          <app-ui-counter
                  [count]="`+${links().length - 1}`"
                  [variant]="'micro'"
                  [matTooltip]="links().length > 1 ? linksDisplay().slice(1).join('\n') : null">
          </app-ui-counter>
      }
    }
  }
  @if (values() && values().length) {
    @if(separateMultipleValues()) {
      @for (val of values(); track $index; let isLast = $last) {
        <div class="value" matTooltip [class.with-separator]="!isLast" [appOverflowTooltip]="val">{{ val }}</div>
      }
    } @else {
      <div class="value" matTooltip [appOverflowTooltip]="values()[0]">
          {{ values()[0] }}
      </div>

      @if(values().length > 1) {
          <app-ui-counter
                  [count]="`+${values().length - 1}`"
                  [variant]="'micro'"
                  [matTooltip]="values().length > 1 ? values().slice(1).join('\n') : null">
          </app-ui-counter>
      }
    }
  }

  @if (rightIcon()) {
    <app-data-chip-icon [icon]="rightIcon()"></app-data-chip-icon>
  }
  @if (showCopyButton()) {
    <app-ui-button-copy class="copy-button" [showLabel]="false" [textToCopy]="textToCopy()"></app-ui-button-copy>
  }
</div>
